import { trasnformForSaleItems } from "../../core/api/transformers/items.js";
import { FractalSDKError, FractalSDKGetItemsForSaleUnknownError, } from "../../core/error/index.js";
import { useGetItemsForSaleQuery } from "../../queries/items.js";
import { useCallback, useMemo } from 'react';
export const useItemsForSale = ({ limit = 10, sortDirection = 'DESCENDING', sortField = 'LIST_TIME', } = {}) => {
    const { data, error: errorResponse, refetch: refetchQuery, } = useGetItemsForSaleQuery({
        limit,
        sortDirection,
        sortField,
    });
    const refetch = useCallback(() => {
        refetchQuery();
    }, [refetchQuery]);
    const items = useMemo(() => (data === null || data === void 0 ? void 0 : data.items) === undefined ? undefined : trasnformForSaleItems(data.items), [data === null || data === void 0 ? void 0 : data.items]);
    let error;
    if (errorResponse && !(errorResponse instanceof FractalSDKError)) {
        error = new FractalSDKGetItemsForSaleUnknownError(`Unable to retrieve items err = ${errorResponse}`);
    }
    return {
        data: items,
        error,
        refetch,
    };
};
//# sourceMappingURL=use-items-for-sale.js.map